export default __webpack_public_path__ + "static/media/dash_tick_circle_teal.d5fad346.svg";